export const columnToLetter = (column: number): string => {
    let result = "";
    while (column > 0) {
        column--; // Excel columns start from A = 1, so adjust with -1
        result = String.fromCharCode((column % 26) + 65) + result;
        column = Math.floor(column / 26);
    }
    return result;
};
